export const state = {
  expert: null,
  experts: []
}

export default state



// WEBPACK FOOTER //
// ./src/store/module/expert/state.js